import { EmailButton, PreviewButton } from '@components';
import { ServiceHistory } from '@services';
import { Tooltip } from 'antd';
import dayjs from 'dayjs';
import { ColumnActions } from '../ColumnActions';

interface IProps {
  handleOpen: (serviceHistory: ServiceHistory) => void;
  handleEmailOpen: (serviceHistory: ServiceHistory) => void;
  iconOnly?: boolean;
}

// Helper to get abp.session.tenantId safely
function getTenantId() {
  try {
    // @ts-ignore
    return typeof abp !== 'undefined' ? abp.session.tenantId : undefined;
  } catch {
    return undefined;
  }
}

export const Columns = ({ handleOpen, handleEmailOpen, iconOnly = false }: IProps) => [
  {
    title: 'Date',
    key: 'creationTime',
    dataIndex: 'creationTime',
    width: 70,
    render: (creationTime: string) => dayjs(creationTime).format('DD/MM/YYYY'),
  },
  {
    title: 'Service',
    key: 'title',
    width: 120,
    render: (history: ServiceHistory) => {
      const text = [
        ...new Set((history.reminderServices ?? []).map((s) => s.reminderName).filter(Boolean)),
      ].join(', ');
      return (
        <Tooltip title={text}>
          <span style={{ display: 'block', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer' }}>
            {text}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: 'Mileage',
    dataIndex: 'mileage',
    key: 'mileage',
    width: 80,
    render: (mileage: number) => mileage,
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 80,
    align: 'right',
    render: (history: ServiceHistory) => {
      const tenantId = getTenantId();
      const allowUpdate =
        tenantId !== undefined &&
        history.tenantId === tenantId &&
        history.creationTime &&
        dayjs().diff(dayjs(history.creationTime), 'month', true) < 1;
      return (
        <ColumnActions
          hideDelete
          hideEdit
          extraAction={
            <>
              {allowUpdate ? (
                <PreviewButton size="small" iconOnly={iconOnly} onClick={() => handleOpen(history)} />
              ) : (
                <PreviewButton
                  size="small"
                  iconOnly={iconOnly}
                  onClick={() => {
                    window.open(`/service-history/${history.vin}`, '_blank');
                  }}
                />
              )}
              <EmailButton size="small" iconOnly={iconOnly} onClick={() => handleEmailOpen(history)} />
            </>
          }
        />
      );
    },
  },
];
